<template>
	<div class="basic-layout">
		<basic-layout-h v-if="!isVerticalScreen()" />
		<basic-layout-v v-else />
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import BasicLayoutH from './BasicLayoutH.vue';
	import BasicLayoutV from './BasicLayoutV.vue'
	export default {
		name: 'BasicLayout',
		components: {
			BasicLayoutH,
			BasicLayoutV
		},
		data() {
			return {
				menuList: [{
					caption: '核心技术',
					captionEn: 'CORE TECHNOLOGY'
				}, {
					caption: '产品服务',
					captionEn: 'PRODUCTS AND SERVICES'
				}, {
					caption: '项目案例',
					captionEn: 'PROJECT CASES'
				}, {
					caption: '关于蓝鲸',
					captionEn: 'ABOUT US'
				}],
				productMenuList: ['不锈钢雕塑', '铜雕', '玻璃钢结构', '装配式钢结构']
			}
		},
		computed: {},
		methods: {
			...mapGetters(["isVerticalScreen"]),
		}
	}
</script>

<style scoped lang="less">
	div {
		//border: 1px solid #000000;
	}
	.basic-layout {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: 100%;
	}
</style>